import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import {
  updateBidsList,
  placeBid,
  findBidData
} from 'src/redux/actions/bidding';
import { sendNotification } from 'src/redux/actions/notifications';
import {
  getLocale,
  getAllStock,
  getAllStockIds,
  getUser,
  getTimeStamp,
  getBidData
} from 'src/redux/selectors';
import {
  addStock,
  deleteStock,
  findAllStock,
  deleteStockImage,
  findAllAccess,
  findAllStockRequests
} from 'src/redux/actions/stock';
import { findTechnicians } from 'src/redux/actions/request';
import { withRouter, Link } from 'react-router-dom';
import { findAllSites, findAllSitesInventory } from 'src/redux/actions/sites';
import { findAllUsers } from 'src/redux/actions/admin';

class Stock extends Component {
  render = () => {
    const {
      Layout,
      currentLocale,
      stock,
      user,
      findAllStock,
      findAllUsers,
      addStock,
      deleteStock,
      sendNotification,
      findAllSitesInventory,
      deleteStockImage,
      findAllSites,
      findAllStockRequests,
      sites,
      inventorySites,
      findAllAccess,
      access,
      findTechnicians,
      push,
      history
    } = this.props;
    return (
      <Layout
        currentLocale={currentLocale}
        findAllSitesInventory={findAllSitesInventory}
        stock={stock}
        user={user}
        access={access}
        findAllStock={findAllStock}
        findAllUsers={findAllUsers}
        findAllAccess={findAllAccess}
        addStock={addStock}
        findAllStockRequests={findAllStockRequests}
        deleteStockImage={deleteStockImage}
        deleteStock={deleteStock}
        sendNotification={sendNotification}
        push={push}
        findAllSites={findAllSites}
        sites={sites}
        inventorySites={inventorySites}
        history={history}
      />
    );
  };
}

const mapStateToProps = state => ({
  currentLocale: getLocale(state) || {},
  sites: state.sites.allSites || [],
  inventorySites: state.sites.inventorySites || [],
  access: state.stock.allAccess || [],
  stock: state.stock.allStock || [],
  user: getUser(state) || {}
});

const mapDispatchToProps = {
  getLocale,
  findAllStock,
  findAllUsers,
  addStock,
  deleteStockImage,
  findAllSitesInventory,
  deleteStock,
  findAllStockRequests,
  sendNotification,
  findAllSites,
  push
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Stock)
);
